import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('./views/Index.vue')

const QuestionV2 = () => import('./views/v2/Question.vue')

const MasterStart = () => import('./views/MasterStart.vue')
const MasterShare = () => import('./views/MasterShare.vue')
const Join = () => import('./views/Join.vue')
const JoinStart = () => import('./views/JoinStart.vue')
const Finish = () => import('./views/Finish.vue')
const Preview = () => import('./views/Preview.vue')
const LandingPreview = () => import('./views/LandingPreview.vue')
const Edit = () => import('./views/Edit.vue')
const Quiz = () => import('./views/Quiz.vue')
const Result = () => import('./views/Result.vue')
const Summary = () => import('./views/Summary.vue')
const MasterResult = () => import('./views/MasterResult.vue')
const MasterResultLanding = () => import('./views/MasterResultLanding.vue')
const MasterSummary = () => import('./views/MasterSummary.vue')
const Thanks = () => import('./views/Thanks.vue')
const RedirectQuiz = () => import('./views/RedirectQuiz.vue')
const LiveLanding = () => import('./views/LiveLanding.vue')
const LiveShare = () => import('./views/LiveShare.vue')
const LiveResult = () => import('./views/LiveResult.vue')
const LiveResultRedirect = () => import('./views/LiveResultRedirect.vue')
const LiveSummary = () => import('./views/LiveSummary.vue')
const MasterRedirectSetting = () => import('./views/MasterRedirectSetting.vue')
const CountDown = () => import('./views/CountDown.vue')
const MasterCountDown = () => import('./views/MasterCountDown.vue')
const PlayAlone = () => import('./views/PlayAlone.vue')
const PlayAloneResult = () => import('./views/PlayAloneResult.vue')
const PlayAloneSummary = () => import('./views/PlayAloneSummary.vue')
const PlayAloneStart = () => import('./views/PlayAloneStart.vue')
const PlayTogether = () => import('./views/PlayTogether.vue')
const MyQuiz = () => import('./views/MyQuiz.vue')
const Me = () => import('./views/Me.vue')
const ResetPassword = () => import('./views/ResetPassword.vue')
const Order = () => import('./views/Order.vue')
const Report = () => import('./views/Report.vue')
const SubscriptionLanding = () => import('./views/SubscriptionLanding.vue')
const SubscriptionLandingVipps = () => import('./views/SubscriptionLandingVipps.vue')
const SetShareQuiz = () => import('./views/SetShareQuiz.vue')
const TermsAncConditions = () => import('./views/TermsConditions.vue')
const Creators = () => import('./views/Creators.vue')
const PrivacyPolicy = () => import('./views/PrivacyPolicy.vue')
const WhatIsTheBigQuiz = () => import('./views/WhatIsTheBigQuiz.vue')
const Page = () => import('./views/Page.vue')
const BuyCredit = () => import('./views/BuyCredit.vue')
const Purchase = () => import('./views/Purchase.vue')
const VippsPaymentLanding = () => import('./views/VippsPaymentLanding.vue')
const VippsOpenner = () => import('./views/VippsOpenner.vue')
const SocketLog = () => import('./views/SocketLog.vue')
const VippsLoginLanding = () => import('./views/VippsLoginLanding.vue')
const ConfirmEmail = () => import('./views/ConfirmEmail.vue')
const Login = () => import('./views/Login.vue')
const LoginSkoler = () => import('./views/LoginSkoler.vue')
const RegisterSchool = () => import('./views/RegisterSchool.vue')
const Invoice = () => import('./views/Invoice.vue')
const Unsubscribe = () => import('./views/Unsubscribe.vue')

import store from '@/store'
import UserService from '@/lib/user'
import appConfig from '@/app.config'
import Cookies from 'js-cookie'

function requireCompleteQuestion(to, form, next) {

    var isTitleFilled = store.state.question.title.length
    var toParamsId = to.params.id

    if (!isTitleFilled && !(['preview'].indexOf(to.name) > -1)) {
        if (toParamsId) {
            next({
                path: `/edit/${toParamsId}`,
                query: to.query
            })
        } else {
            window.location.href = '/'
        }
    }

    next()
}

function requireLoadedQuestion(to, from, next) {

    var isQuestionEmpty = !store.state.player.quiz.title.length

    if (isQuestionEmpty) {
        next({
            path: '/'
        })
    }

    next()
}

function requireLoadedQuizCode(to, from, next) {
    var isQuestionEmpty = !store.state.player.quiz.title

    if (isQuestionEmpty) {
        window.location.href = '/'
    }

    next()
}

function requiredLoggedIn(to, from, next) {
    const userService = new UserService()

    const isSchool = userService.getUser().school_id ? true : false

    if (!userService.isLoggedIn()) {
        if (isSchool) {
            window.location.href = process.env.VUE_APP_NUXT_BASE_URL + '/skoler?login=true'
        } else {
            next({
                path: '/login',
                query: {
                    path: btoa(to.fullPath)
                }
            })
        }
    }

    next()
}

function checkRolesBeforeEnter(to, from, next) {
    const userService = new UserService()
    const isSchool = to.fullPath && to.fullPath.includes('/skoler')
    const isFeide = userService.getUserFeide()
    const provider = userService.getStoredProvider()
    const isFeideProvider = provider === 'feide'

    if (!userService.isLoggedIn()) {
        userService.removeFeideToken()

        next({
            path: isSchool || isFeide || isFeideProvider ? '/login-skoler' : '/login',
            query: {
                path: btoa(to.fullPath)
            }
        })
    }

    if (['student_plus', 'student'].includes(userService.getUser().role)) {
        location.href = `${process.env.VUE_APP_NUXT_BASE_URL}/skoler/join`
    }

    if (to.name === 'my-quiz') {
        const listLocale = appConfig.supportedLanguages

        const geoCode = store && store.state.geoLocation && store.state.geoLocation.code.toLowerCase()
        const localeCode = Cookies.get('lang')
        let code = 'en'

        if (listLocale.includes(geoCode)) {
            code = geoCode
        }

        if (listLocale.includes(localeCode)) {
            code = localeCode
        }

        next({
            name: 'my-quiz-locale',
            params: {
                locale: code
            },
            query: to.query,
            hash: to.hash
        })
    }

    next()
}

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: Home
        },
        {
            path: '/create-quiz',
            name: 'setting',
            component: MyQuiz
        },
        {
            path: '/setting',
            name: 'setting',
            component: MyQuiz
        },
        {
            path: '/maowmaow',
            component: SocketLog
        },
        {
            path: '/my-quiz',
            name: 'my-quiz',
            component: MyQuiz,
            beforeEnter: checkRolesBeforeEnter
        },
        {
            path: '/my-quiz/:locale',
            name: 'my-quiz-locale',
            component: MyQuiz,
            beforeEnter: checkRolesBeforeEnter
        },
        {
            path: '/subscription',
            name: 'plan',
            component: Purchase
        },
        {
            path: '/purchase',
            name: 'purchase',
            component: Purchase
        },
        {
            path: '/skoler/purchase',
            name: 'skoler-purchase',
            component: Purchase
        },
        {
            path: '/school/purchase',
            name: 'school-purchase',
            component: Purchase
        },
        {
            path: '/vipps-openner',
            name: 'vipps-payment.openner',
            component: VippsOpenner
        },
        {
            path: '/vipps-payment-landing',
            name: 'vipps-payment.landing',
            component: VippsPaymentLanding
        },
        {
            path: '/vipps-login-landing',
            name: 'vipps-login.landing',
            component: VippsLoginLanding
        },
        {
            path: '/subscription/:status',
            name: 'subscription.landing',
            component: SubscriptionLanding
        },
        {
            path: '/subscription-vipps',
            name: 'SubscriptionLandingVipps.landing',
            component: SubscriptionLandingVipps
        },
        {
            path: '/my-quiz/edit/:id',
            name: 'edit-my-quiz',
            component: MyQuiz,
            beforeEnter: requiredLoggedIn
        },
        {
            path: '/me',
            name: 'me',
            component: Me,
            beforeEnter: requiredLoggedIn
        },
        {
            name: 'buy-credit',
            path: '/buy-credit',
            component: BuyCredit,
            beforeEnter: checkRolesBeforeEnter
        },
        {
            path: '/what-is-the-big-quiz',
            name: 'what-is-the-big-quiz',
            component: WhatIsTheBigQuiz
        },
        {
            path: '/terms-and-conditions',
            name: 'terms-and-conditions',
            component: TermsAncConditions
        },
        {
            path: '/web-privacy-policy',
            name: 'web-privacy-policy',
            component: PrivacyPolicy
        },
        {
            path: '/order',
            name: 'order',
            component: Order,
            beforeEnter: checkRolesBeforeEnter
        },
        {
            path: '/report/:quizId',
            name: 'report',
            component: Report,
            beforeEnter: checkRolesBeforeEnter
        },
        {
            path: '/reset-password/:token',
            name: 'reset-password',
            component: ResetPassword
        },
        {
            path: '/creators',
            name: 'creators',
            component: Creators
        },
        {
            path: '/question',
            name: 'question',
            component: QuestionV2,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/start-quiz/:id',
            name: 'start-quiz',
            component: MasterStart,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/share',
            name: 'share',
            component: MasterShare,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/join',
            name: 'join',
            component: Join
        },
        {
            path: '/join-start',
            name: 'join-start',
            component: JoinStart,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/finish/:type',
            component: Finish
        },
        {
            path: '/preview/:id',
            name: 'preview',
            component: Preview,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/landing-preview/',
            name: 'landing-preview',
            component: LandingPreview
        },
        {
            path: '/edit/:id',
            name: 'edit',
            component: Edit
        },
        {
            path: '/result/:code',
            name: 'result',
            component: Result,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/summary',
            name: 'summary',
            component: Summary,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/master-result',
            name: 'master-result',
            component: MasterResult,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/master-result-landing',
            name: 'master-result-landing',
            component: MasterResultLanding,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/master-summary',
            name: 'master-summary',
            component: MasterSummary,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/thanks',
            name: 'thanks',
            component: Thanks,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/redirect-quiz',
            name: 'redirect-quiz',
            component: RedirectQuiz
        },
        {
            path: '/live/:code',
            name: 'live',
            component: LiveLanding
        },
        {
            path: '/live/share',
            name: 'live-share',
            component: LiveShare,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/live/result',
            name: 'live-result',
            component: LiveResult,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/live/summary',
            name: 'live-summary',
            component: LiveSummary,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/live/redirect',
            name: 'live-redirect',
            component: LiveResultRedirect
        },
        {
            path: '/redirect-setting/:id',
            name: 'redirect-setting',
            component: MasterRedirectSetting
        },
        {
            path: '/countdown/:code',
            name: 'countdown',
            component: CountDown,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '/master-countdown',
            name: 'master-countdown',
            component: MasterCountDown,
            beforeEnter: requireCompleteQuestion
        },
        {
            path: '/play/:code',
            name: 'play-alone',
            component: PlayAlone,
            beforeEnter: requireLoadedQuizCode
        },
        {
            path: '/play/:code/retry',
            name: 'play-alone-retry',
            component: PlayAlone,
            beforeEnter: requireLoadedQuizCode
        },
        {
            path: '/play/:code/result',
            name: 'play-alone-result',
            component: PlayAloneResult,
            beforeEnter: requireLoadedQuizCode
        },
        {
            path: '/play/:code/summary',
            name: 'play-alone-summary',
            component: PlayAloneSummary,
            beforeEnter: requireLoadedQuizCode
        },
        {
            path: '/play/:code/start',
            name: 'play-alone-start',
            component: PlayAloneStart
        },
        {
            path: '/play/:id/together',
            name: 'play-together',
            component: PlayTogether
        },
        {
            path: '/set/:id/share/:token',
            name: 'set-share-quiz',
            component: SetShareQuiz
        },
        {
            path: '/skoler/set/:id/share/:token',
            name: 'set-share-skoler-quiz',
            component: SetShareQuiz
        },
        {
            path: '/school/set/:id/share/:token',
            name: 'set-share-school-quiz',
            component: SetShareQuiz
        },
        {
            path: '/article/:slug',
            name: 'page',
            component: Page
        },
        {
            path: '/p/:slug',
            name: 'page',
            component: Page
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/login-skoler',
            name: 'login-skoler',
            component: LoginSkoler
        },
        {
            path: '/unsubscribe',
            name: 'unsubscribe',
            component: Unsubscribe
        },
        {
            path: '/confirm-email/:token',
            name: 'confirm-email',
            component: ConfirmEmail,
            beforeEnter: requiredLoggedIn
        },
        {
            path: '/school/:slug',
            name: 'school',
            component: RegisterSchool
        },
        {
            path: '/invoice/:id',
            name: 'invoice',
            component: Invoice,
            beforeEnter: requiredLoggedIn
        },
        // New router should add before /:code
        {
            path: '/:code',
            name: 'quiz',
            component: Quiz,
            beforeEnter: requireLoadedQuestion
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})
